import { useRecommendedStore } from "@warp-drive/core";
import { JSONAPICache } from "@warp-drive/json-api";
import { PatientSchema } from "parog-web/data/v2-patient/schema";
import { WiseHandler } from "./request-manager";

const Store = useRecommendedStore({
  cache: JSONAPICache,
  // @ts-expect-error todo
  schemas: [PatientSchema],
  handlers: [WiseHandler()]
});

type Store = InstanceType<typeof Store>;

export default Store;
